
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Rueil-Malmaison dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Rueil-Malmaison certifiée Google Partner, soutient les entreprises ruelloises pour accroître leur notoriété en ligne et générer plus de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Rueil-Malmaison dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Rueil-Malmaison certifiée Google Partner, soutient les entreprises ruelloises pour accroître leur notoriété en ligne et générer plus de clients.",
        },
      ],
    };
  },
};
